import React from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { DIRECTORY } from "@/components/landing/landingData";

const Item = ({ d, onOpen }) => (
  <article data-testid={`lp-dir-${d.key}`} className="flex flex-col overflow-hidden rounded-xl border border-white/10 bg-[#060A12] transition-[border-color] duration-200 hover:border-[#22D3EE]/40">
    <div className="aspect-[16/9] overflow-hidden bg-black">
      <img src={d.preview} alt={`${d.name} preview`} loading="lazy" className="h-full w-full object-cover object-top" />
    </div>
    <div className="flex flex-1 flex-col p-4">
      <div className="flex items-center justify-between gap-2">
        <h4 className="font-condensed text-xl font-bold uppercase tracking-wide text-white">{d.name}</h4>
        <span className="rounded-full border border-[#22D3EE]/40 px-2 py-0.5 font-mono text-[9px] font-bold uppercase tracking-widest text-[#22D3EE]">Live</span>
      </div>
      <p className="mt-1.5 text-[13px] leading-relaxed text-slate-400">{d.desc}</p>
      <ul className="mt-3 space-y-1">
        {d.features.map((f) => <li key={f} className="flex items-start gap-2 text-[12px] text-slate-300"><Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#22D3EE]" />{f}</li>)}
      </ul>
      <button data-testid={`lp-dir-open-${d.key}`} onClick={() => onOpen(d.key, d.name)} className="mt-auto inline-flex items-center gap-1.5 pt-4 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-[#22D3EE] transition-colors hover:text-white">
        Open Dashboard <ArrowUpRight className="h-4 w-4" />
      </button>
    </div>
  </article>
);

export const Directory = ({ onOpen }) => (
  <section id="dashboards" data-testid="lp-directory" className="scroll-mt-16 border-t border-white/5 py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-[#22D3EE]">Dashboard directory</p>
      <h2 className="mt-3 font-condensed text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">Every dashboard. One platform.</h2>
      <p className="mt-2 max-w-2xl text-sm text-slate-400">All {DIRECTORY.reduce((n, g) => n + g.items.length, 0)} dashboards below are live today and open with a free account.</p>
      {DIRECTORY.map((g) => (
        <div key={g.group} className="mt-12" data-testid={`lp-dir-group-${g.group.split(" ")[0].toLowerCase()}`}>
          <h3 className="flex items-center gap-3 font-mono text-xs font-bold uppercase tracking-[0.3em] text-slate-200">
            <span className="h-px w-8 bg-[#22D3EE]" />{g.group}
          </h3>
          <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {g.items.map((d) => <Item key={d.key} d={d} onOpen={onOpen} />)}
          </div>
        </div>
      ))}
    </div>
  </section>
);
